// CHG-1283 / ITER-3408 — v2 welcome-overlay localStorage state.
//
// Two flags, both written by WelcomeOverlay:
//   v2-welcome-completed  → user reached step 4 ("Try it out")
//   v2-welcome-dismissed  → user dismissed at any step (Esc / backdrop / X)
//
// Either flag suppresses future first-visit triggers. The
// "Replay welcome tour" affordance in Settings clears BOTH.

export const STORAGE_KEY_COMPLETED = "v2-welcome-completed";
export const STORAGE_KEY_DISMISSED = "v2-welcome-dismissed";

export function isWelcomeNeeded(): boolean {
  if (typeof window === "undefined") return false;
  try {
    const completed = window.localStorage.getItem(STORAGE_KEY_COMPLETED);
    const dismissed = window.localStorage.getItem(STORAGE_KEY_DISMISSED);
    return completed !== "true" && dismissed !== "true";
  } catch {
    return false;
  }
}

export function markCompleted(): void {
  try {
    window.localStorage.setItem(STORAGE_KEY_COMPLETED, "true");
    // CHG-1287 — additive: dispatch a same-tab CustomEvent so the
    // AdoptionTelemetry surface can fire welcome_completed without
    // tightly coupling storage.ts to the telemetry batch client.
    window.dispatchEvent(new CustomEvent("v2-welcome-completed"));
  } catch {
    // ignore — incognito / quota; suppression is best-effort
  }
}

export function markDismissed(): void {
  try {
    window.localStorage.setItem(STORAGE_KEY_DISMISSED, "true");
    // CHG-1287 — additive: dispatch a same-tab CustomEvent (see markCompleted).
    window.dispatchEvent(new CustomEvent("v2-welcome-dismissed"));
  } catch {
    // ignore
  }
}

export function clearWelcomeFlags(): void {
  try {
    window.localStorage.removeItem(STORAGE_KEY_COMPLETED);
    window.localStorage.removeItem(STORAGE_KEY_DISMISSED);
  } catch {
    // ignore
  }
}
